module.exports = __webpack_public_path__ + "static/media/1124_Punchcard_1K.9ba7fa66.glb";